import produce from 'immer';
import { addSelectedFlight, setExchangeVariants, removeLastSelectedFlight, clearExchangeVariants, setExchangeVariantPrices, setActualSelectedFlightPriceId } from './actions';
const initialState = {
    selectedFlights: [],
    flightDirections: [],
    exchangeVariantPriceInfo: []
};
function exchangeVariantsReducer(state = initialState, { type, payload }) {
    return produce(state, draft => {
        switch (type) {
            case addSelectedFlight.toString():
                draft.selectedFlights.push(payload);
                break;
            case setActualSelectedFlightPriceId.toString():
                draft.selectedFlights = draft.selectedFlights.map(selectedFlight => selectedFlight.priceId === payload.priceId
                    ? Object.assign(Object.assign({}, selectedFlight), { actualPriceId: payload.actualPriceId }) : selectedFlight);
                break;
            case setExchangeVariants.toString():
                draft.flightDirections = payload.flightDirections;
                draft.exchangeVariantPriceInfo = payload.exchangeVariantPriceInfo;
                break;
            case setExchangeVariantPrices.toString():
                draft.exchangeVariantPriceInfo = payload;
                break;
            case removeLastSelectedFlight.toString():
                draft.selectedFlights.pop();
                break;
            case clearExchangeVariants.toString():
                draft.selectedFlights = [];
                draft.flightDirections = [];
                draft.exchangeVariantPriceInfo = [];
                break;
        }
    });
}
export default exchangeVariantsReducer;
